// extracted by mini-css-extract-plugin
export default {"container":"NvMeasureYourImpact_container__qeyAC","whySection":"NvMeasureYourImpact_whySection__gjKOc","measureImpact":"NvMeasureYourImpact_measureImpact__asmr5"};